import {
    mapGetters,
    mapActions
} from 'vuex';

import { api } from '_/services/api';

export default {
    /**
     * Set the component's data storage
     *
     * @return  {void}
     */
    data: function() {
        return {
            terms: '',
        };
    },

    /**
     * Set the computed variables
     *
     * @type  {object}
     */
    computed: mapGetters({
        ui: 'ui/ui'
    }),

    /**
     * Set the methods
     *
     * @type  {Object}
     */
    methods: {
        ...mapActions('ui', [ // Map actions from ui module namespace
            'setBodyClass',
            'setTitle'
        ]),

        getTerms () {
            return api.get('get_terms')
                .then((response) => {
                    this.terms = response.body.body.text;
                });
            },
    },

    /**
     * Call a mounted hook
     *
     * @type  {function}
     * @return  void
     */
    mounted: function() {
        this.$nextTick(function() {
            this.getTerms();

            this.setBodyClass('login-page');

            this.setTitle('Uslovi korišćenja');
        });
    },
};
